import React, { Fragment, useContext, useEffect, useState } from "react";
import { setCurrentScreen } from "firebase/analytics";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { SaleOrder, SaleOrderLineItem } from "../../container/SaleBook";
import withObservables from "@nozbe/with-observables";
import styles from "./styles.module.css";
import {
  observeActiveSaleOrderByBusiness,
  ObserveDraftSaleOrderByBusiness,
} from "../../../database/helpers/sale_order";
import { InnerWrapper, TitleAndActionBox } from "../../common";
import { Grid } from "@mui/material";
import { KeyboardShortcutsModal, ParagraphText, UBButton } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import { ArrowDown, ArrowUp, Keyboard } from "../../../assets/icons/icon";
import { Box, Tooltip } from "@mui/material";

const KeyboardShortcutKey = [
  { btnTitle: "Space", label: "Switch between the tabs", labelKey: "shortcut_switch_tabs", column: "left" },
  { btnTitle: "Enter", label: "Add items to cart", labelKey: "shortcut_add_items_to_cart", column: "left" },
  { btnTitle: "Shift + n", label: "Start new sale", labelKey: "shortcut_start_new_sale", column: "left" },
  { btnTitle: "Shift + Enter", label: "Go to checkout", labelKey: "shortcut_go_to_checkout", column: "left" },
  { btnTitle: "Shift + f", label: "Search items", labelKey: "shortcut_search_items", column: "right" },
  { btnTitle: <ArrowUp />, label: "Scroll up items list", labelKey: "shortcut_scroll_up_items", column: "right" },
  { btnTitle: <ArrowDown />, label: "Scroll down items list", labelKey: "shortcut_scroll_down_items", column: "right" },
];
const SaleBook = ({ observeActiveSaleOrder, draftOrders }) => {
  const { user, business } = useAuthContext();
  const activeSaleOrder = observeActiveSaleOrder.length
    ? observeActiveSaleOrder[0]
    : observeActiveSaleOrder;

  const [I18n] = useContext(LanguageContext);
  const [customer, setCustomer] = useState(null);
  const [draftListModal, setDraftListModal] = useState(false);
  const [shortcutKeyModal, setShortcutKeyModal] = useState(false);
  const [showDraftSavedTooltip, setShowDraftSavedTooltip] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const createSaleOrder = async () => {
    try {
      if (observeActiveSaleOrder.length === 0) {
        await business?.createSaleOrder({
          status: "active",
        });
        setCustomer(null);
        // Sync(user.phone_number, navigate);
      } else {
      }
    } catch (error) {}
  };

  const handleSetCustomer = async () => {
    try {
      if (activeSaleOrder.length === 0) {
        setCustomer(null);
      } else {
        setCustomer(await activeSaleOrder?.customer.fetch());
      }
    } catch (error) {}
  };

  useEffect(() => {
    handleSetCustomer();
  }, [activeSaleOrder]);

  useEffect(() => {
    createSaleOrder();
  }, []);

  const addCustomer = async (customer) => {
    try {
      setCustomer(customer);
      await activeSaleOrder.updateSaleOrderCustomer(customer);
    } catch (error) {}
  };

  const handleDraftSaved = () => {
    setShowDraftSavedTooltip(true);
    setTimeout(() => setShowDraftSavedTooltip(false), 2200);
  };

  return (
    <Box className={styles.SaleBookWrapper}>
      <Box>
        <TitleAndActionBox
          data={{
            id: "sale_pos",
            title: "sale_pos",
            isTitleCase: false,
            isBack: true,
            onBack: () =>
              navigate(location?.state?.pathname || "/POS", {
                state: { saleMode: "sale_pos" },
              }),
          }}
        >
          <Tooltip title={I18n.keyboard_shortcut_tooltip || "Keyboard shortcut"}>
            <UBButton
              id="shortcut_shortcut"
              className={"keyboardButton buttonTeritary buttonTeritaryIcon"}
              title={<Keyboard width={30} height={30} />}
              onClick={() => {
                triggerLogEvent(analytics, "pos_keyboard_icon");
                setShortcutKeyModal(true);
              }}
            />
          </Tooltip>
          <Tooltip
            open={showDraftSavedTooltip}
            title={<ParagraphText className={"fontSize12 bgPrimary fontWeight400"} >{I18n.order_saved_into_draft_sales}</ParagraphText>}
            placement="bottom-end"
            disableFocusListener
            disableHoverListener
            disableTouchListener
            slotProps={{
              tooltip: {
                sx: {
                  background: "var(--mainColor)",
                  color: "var(--white)",
                  borderRadius: "3px",
                  padding: "12px",
                  fontSize: "12px",
                  fontWeight: 500,
                  boxShadow:
                    "0px 12px 42px -4px #18274B1F, 0px 8px 18px -6px #18274B1F",
                },
              },
              arrow: {
                sx: {
                  color: "#0C1536",
                },
              },
            }}
            arrow
          >
            <Box>
              <UBButton
                id="draft_sale_btn"
                title={`${I18n.draft_sale} (${draftOrders?.length || 0})`}
                onClick={() => {
                  triggerLogEvent(analytics, "pos_draft_sale", {});
                  setDraftListModal(true);
                }}
                className={"buttonTeritary marginLeft15"}
              />
            </Box>
          </Tooltip>
        </TitleAndActionBox>
        <InnerWrapper className={"splitInnerWrapper"}>
          <Grid
            container
            sx={{
              height: "100%",
              minHeight: 0,
              minWidth: 0,
              flex: 1,
              width: "100%",
              margin: 0,
            }}
          >
            <Grid
              item
              md={6}
              sx={{
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                minWidth: 0,
                height: "100%",
              }}
            >
              <SaleOrder
                navigate={navigate}
                activeSaleOrder={activeSaleOrder}
                business={business}
                user={user}
                setDraftListModal={setDraftListModal}
                draftListModal={draftListModal}
              />
            </Grid>
            <Grid
              item
              md={6}
              sx={{
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                minWidth: 0,
                height: "100%",
              }}
            >
              <SaleOrderLineItem
                activeSaleOrder={activeSaleOrder}
                setCustomer={addCustomer}
                selectedCustomer={customer}
                navigate={navigate}
                user={user}
                business={business}
                onDraftSaved={handleDraftSaved}
              />
            </Grid>
          </Grid>
        </InnerWrapper>
      </Box>
      <KeyboardShortcutsModal
        id="sale_pos"
        isOpen={shortcutKeyModal}
        handleClose={() => setShortcutKeyModal(false)}
        shortcuts={KeyboardShortcutKey}
      />
    </Box>
  );
};

const enhance = withObservables(["active_sale_order"], () => ({
  observeActiveSaleOrder: observeActiveSaleOrderByBusiness(
    localStorage.getItem("business_id"),
  ),
  draftOrders: ObserveDraftSaleOrderByBusiness(
    localStorage.getItem("business_id") ?? "",
  ),
}));

export default enhance(SaleBook);
